import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialogActions, MatDialogClose, MatDialogContent,
    MatDialogModule, MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'cost-review-unlock',
    templateUrl: './cost-review-unlock.component.html',
    styleUrls: ['./cost-review-unlock.component.scss'],
    imports: [
        CommonModule,
        TranslatePipe,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatDialogContent
    ]
})
export class CostReviewUnlockComponent {
    constructor(
        public dialogRef: MatDialogRef<CostReviewUnlockComponent>
    ) {
    }

    onConfirmClick(): void {
        this.dialogRef.close({ isUnlockRequested: true });
    }
}
